import { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom"; // NEW
import kouLogo from "../images/koulogo.png";
import studentHomeImg from "../images/megaphone.svg";
import studentHomeImg2 from "../images/adminhome.svg";
import api from "../services/api";
import "./pagesStyles/StudentHomePage.css";
import TimesheetCalendar from "../components/TimesheetCalendar"; // NEW

import aileSaglikDoc from "../documents/aile_saglik.pdf";
import sozlesmeDoc from "../documents/sozlesme.pdf";
import applicationFormFile from "../documents/basvuru.pdf";


function StudentHomePage() {
  const [activeTab, setActiveTab] = useState("anasayfa");
  const [availableUnits, setAvailableUnits] = useState([]);
  const [selectedWorkplace, setSelectedWorkplace] = useState("");
  const [unitDropdownOpen, setUnitDropdownOpen] = useState(false);
  const [selectedWorkplaceLabel, setSelectedWorkplaceLabel] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [filterStatus, setFilterStatus] = useState("all");
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [blockedWorkplaces, setBlockedWorkplaces] = useState(new Set());
  const [announcementData, setAnnouncementData] = useState(null);
  const [isAnnouncementActive, setIsAnnouncementActive] = useState(true);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [reqUploads, setReqUploads] = useState({}); // { [requirementId]: File }
  const [ibanText, setIbanText] = useState(""); // NEW: typed IBAN next to "İban Gösterir Belge"
  // NEW: input-level validation state
  const [ibanTouched, setIbanTouched] = useState(false);
  const [documentSubmissionStatus, setDocumentSubmissionStatus] = useState(null);
  const [hasAsilSubmission, setHasAsilSubmission] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [applicationsPerPage] = useState(5);
  const [showStudentInfoModal, setShowStudentInfoModal] = useState(false);
  const [studentInfo, setStudentInfo] = useState({ adSoyad: "", tcNo: "" });
  const [notifications, setNotifications] = useState([]);       // NEW
  const [unreadCount, setUnreadCount] = useState(0);            // NEW
  const [notifOpen, setNotifOpen] = useState(false);            // NEW
  const [notifLoading, setNotifLoading] = useState(false);      // NEW

  // NEW: notification polling refs/state
  const [notifMetaVersion, setNotifMetaVersion] = useState(0);
  const notifPollTimerRef = useRef(null);
  const notifPollBackoffRef = useRef(12000);
  const doNotifPollRef = useRef(null);

  // PART-TIME + TIMESHEET
  const [employment, setEmployment] = useState(null);           // NEW
  const [ts, setTs] = useState(null);                           // NEW
  const [tsLoading, setTsLoading] = useState(false);            // NEW
  const [tsEditMode, setTsEditMode] = useState(false);          // NEW: takvim düzenleme modu
  const navigate = useNavigate(); // NEW
  const logoutTimerRef = useRef(null); // NEW
  const unitDropdownRef = useRef(null);

  // NEW: polling state/refs
  const [appsMetaVersion, setAppsMetaVersion] = useState(0);
  const appsPollTimerRef = useRef(null);
  const appsPollBackoffRef = useRef(12000); // 12s
  const doAppsPollRef = useRef(null);

  // Role-özgü ve sekmeye özel kullanıcı okuma
  const getStudentUser = useCallback(() => {
    try {
      const s1 = sessionStorage.getItem('studentUser');
      if (s1) return JSON.parse(s1);
      const l1 = localStorage.getItem('studentUser');
      if (l1) return JSON.parse(l1);
      const fallback = localStorage.getItem('user');
      if (fallback) {
        const u = JSON.parse(fallback);
        return u?.type === 'student' ? u : null;
      }
      return null;
    } catch { return null; }
  }, []);

  // Requirements: add 6th row for IBAN text input
  const requirements = [
    { id: 1, key: "contract", name: "Kısmi Zamanlı Öğrenci ÇalışSözleşmesitırma ", downloadable: true, file: sozlesmeDoc },
    { id: 2, key: "ogrenci-belgesi", name: "Yeni Tarihli Öğrenci Belgesi", downloadable: false },
    { id: 3, key: "aile-saglik", name: "Aile Sağlık Yardımı Sorgulama Belgesi", downloadable: true, file: aileSaglikDoc },
    { id: 4, key: "kimlik", name: "Kimlik Fotokopisi", downloadable: false },
    { id: 5, key: "iban", name: "İban Gösterir Belge", downloadable: false },
    { id: 6, key: "iban-text", name: "Ziraat Bankası IBAN", downloadable: false } // NEW
  ];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchAvailableUnits();
    fetchMyActiveApplications();
    fetchDocumentSubmissionStatus();
    
    // Load announcement from localStorage
    const saved = localStorage.getItem("announcementData");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed?.title && typeof parsed.content === "string") {
          setAnnouncementData(parsed);
        }
      } catch (e) {
        console.error("Announcement data parse error:", e);
      }
    }

    // Load announcement status
    const announcementStatus = localStorage.getItem("announcementActive");
    if (announcementStatus !== null) {
      setIsAnnouncementActive(JSON.parse(announcementStatus));
    }

    const token = localStorage.getItem("token");
    const expStr = localStorage.getItem("tokenExpiresAt");
    if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
    if (expStr) {
      const msLeft = parseInt(expStr, 10) - Date.now();
      if (msLeft <= 0) {
        handleLogout();
      } else {
        logoutTimerRef.current = setTimeout(() => handleLogout(), msLeft);
      }
    }

    // İlk yüklemede bildirimleri getir
    fetchNotifications(); // NEW
    // NEW: aktif part-time var mı?
    fetchEmployment(); // NEW

    // NEW: trigger daily reminder tick (idempotent)
    (async () => { try { await api.post("/admin/reminders/period-end/tick"); } catch {} })();

    return () => {
      if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
    };
  }, []);

  // Başvuru formu indirme fonksiyonu
  const handleDownloadPDF = () => {
    const link = document.createElement('a');
    link.href = applicationFormFile;
    link.download = 'kismi_zamanli_ogrenci_calistirma_basvuru_formu.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fetchAvailableUnits = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get("/student/available-units");
      if (response.data.success) {
        setAvailableUnits(response.data.data);
      }
    } catch (error) {
      console.error("Müsait birimler getirilirken hata:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  // Dosya yükleme
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      setUploadedFile(file);
    } else {
      alert('Lütfen sadece PDF dosyası yükleyiniz.');
    }
  };

  // Workplace seçildiğinde
  const buildWorkplaceLabel = useCallback((key) => {
    if (!key) return "";
    const [unitId, workplaceId] = key.split("|");
    const unit = availableUnits.find((u) => u._id === unitId);
    if (!unit) return "";
    const workplace = unit.workplaces.find((wp) => wp._id === workplaceId);
    if (!workplace) return "";
    const disabled = blockedWorkplaces.has(key);
    return `${unit.ustBirim.ustKurum} - ${unit.birimAdi} - ${workplace.calisacakYer} (${workplace.isAdi}) - Müsait: ${workplace.bosKontenjan}${disabled ? " (Başvuruldu)" : ""}`;
  }, [availableUnits, blockedWorkplaces]);

  const handleWorkplaceChange = (workplaceValue) => {
    setSelectedWorkplace(workplaceValue);
    setUnitDropdownOpen(false);
  };

  useEffect(() => {
    setSelectedWorkplaceLabel(buildWorkplaceLabel(selectedWorkplace));
  }, [selectedWorkplace, buildWorkplaceLabel]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (unitDropdownRef.current && !unitDropdownRef.current.contains(event.target)) {
        setUnitDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Başvuru gönder - modal aç
  const handleSubmitApplication = async () => {
    if (!selectedWorkplace || !uploadedFile) {
      alert('Lütfen çalışmak istediğiniz alanı seçiniz ve belgenizi yükleyiniz.');
      return;
    }
    setShowStudentInfoModal(true);
  };

  const handleCloseModal = () => {
    setShowStudentInfoModal(false);
    setStudentInfo({ adSoyad: "", tcNo: "" });
  };

  const handleStudentInfoChange = (field, value) => {
    setStudentInfo(prev => ({ ...prev, [field]: value }));
  };

  // Modal onayla -> gerçek gönderim
  const handleConfirmApplication = async () => {
    if (!studentInfo.adSoyad.trim() || !studentInfo.tcNo.trim()) {
      alert('Lütfen ad-soyad ve TC kimlik numaranızı giriniz.');
      return;
    }
    if (studentInfo.tcNo.length !== 11 || !/^\d+$/.test(studentInfo.tcNo)) {
      alert('TC kimlik numarası 11 haneli olmalı ve sadece rakam içermelidir.');
      return;
    }

    try {
      const userData = getStudentUser();
      if (!userData || !userData.sicilNo) {
        alert('Giriş bilgileriniz bulunamadı. Lütfen tekrar giriş yapınız.');
        return;
      }

      const [unitId, workplaceId] = selectedWorkplace.split('|');
      const formData = new FormData();
      formData.append('studentSicilNo', userData.sicilNo);
      formData.append('unitId', unitId);
      formData.append('workplaceId', workplaceId);
      formData.append('applicationDocument', uploadedFile);
      formData.append('adSoyad', studentInfo.adSoyad.trim());
      formData.append('tcNo', studentInfo.tcNo.trim());

      const response = await api.post('/student/applications', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.data.success) {
        alert('Başvurunuz başarıyla alınmıştır!');

        // 1) Seçilen alanı anında tekrar başvuruyu engellemek için blokla (optimistic update)
        const appliedKey = `${unitId}|${workplaceId}`;
        setBlockedWorkplaces(prev => {
          const next = new Set(prev);
          next.add(appliedKey);
          return next;
        });

        // 2) Listeleri yenile (ekranda müsaitlik/etiketler güncellensin)
        fetchMyActiveApplications();  // aktif başvurulara göre bloklu alanları güncelle
        fetchAvailableUnits();        // müsait birimler/alanlar listesini tazele
        fetchStudentApplications();   // öğrencinin başvurularını yenile

        // 3) Formu sıfırla ve modalı kapat
        setSelectedWorkplace("");
        setUploadedFile(null);
        setStudentInfo({ adSoyad: "", tcNo: "" });
        setShowStudentInfoModal(false);
      }
    } catch (error) {
      console.error('Başvuru gönderilirken hata:', error);
      alert(error.response?.data?.message || 'Başvuru gönderilirken hata oluştu');
    }
  };

  // Öğrenci başvurularını getir
  const fetchStudentApplications = useCallback(async () => {
    try {
      const userData = getStudentUser();
      if (userData && userData.sicilNo) {
        const response = await api.get(`/student/applications/${userData.sicilNo}`);
        if (response.data.success) {
          setApplications(response.data.data);
          setFilteredApplications(response.data.data);
        }
        // NEW: refresh meta version after full fetch
        try {
          const metaResp = await api.get(`/student/applications/${userData.sicilNo}`, { params: { meta: 1 } });
          if (metaResp.data?.meta?.version) setAppsMetaVersion(metaResp.data.meta.version);
        } catch {}
      }
    } catch (error) {
      console.error("Başvurular getirilirken hata:", error);
    }
  }, [getStudentUser]);

  // Pagination calculations
  const indexOfLastApplication = currentPage * applicationsPerPage;
  const indexOfFirstApplication = indexOfLastApplication - applicationsPerPage;
  const currentApplications = filteredApplications.slice(indexOfFirstApplication, indexOfLastApplication);
  const totalPages = Math.ceil(filteredApplications.length / applicationsPerPage);


  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Reset to first page when filter changes
  const filterApplications = (status) => {
    setFilterStatus(status);
    setShowFilterDropdown(false);
    setCurrentPage(1); // Reset to first page when filtering
    
    if (status === "all") {
      setFilteredApplications(applications);
    } else {
      const filtered = applications.filter(app => app.status === status);
      setFilteredApplications(filtered);
    }
  };

  // Öğrencinin aktif başvurularını getir (aynı unit+workplace'e tekrar başvuruyu engelle)
  const fetchMyActiveApplications = useCallback(async () => {
    try {
      const userData = getStudentUser();
      if (!userData?.sicilNo) return;
      const resp = await api.get(`/student/applications/${userData.sicilNo}`);
      if (resp.data.success) {
        const active = resp.data.data.filter(a => ["beklemede", "asil", "yedek"].includes(a.status));
        const keys = active.map(a => `${a.unit._id}|${a.workplace}`); // workplace is raw id in response
        setBlockedWorkplaces(new Set(keys));
      }
    } catch (e) {
      console.error("Aktif başvurular getirilirken hata:", e);
    }
  }, [getStudentUser]);

  // Fetch document submission status
  const fetchDocumentSubmissionStatus = useCallback(async () => {
    try {
      const userData = getStudentUser();
      if (!userData?.sicilNo) return;

      const response = await api.get(`/student/document-status/${userData.sicilNo}`);
      if (response.data.success) {
        setDocumentSubmissionStatus(response.data.data);
        setHasAsilSubmission(response.data.data.hasAsilSubmission);
      }
    } catch (error) {
      console.error("Belge durumu getirilirken hata:", error);
      // Keep state but avoid crashes in UI
      setDocumentSubmissionStatus(prev => prev || { submittedApplicationIds: [], submissions: [] });
    }
  }, [getStudentUser]);

  // Fetch notifications
  const fetchNotifications = useCallback(async (options = { silent: false }) => {
    const { silent } = options;
    try {
      const user = getStudentUser();
      if (!user?.sicilNo) return;
      if (!silent) setNotifLoading(true);
      const resp = await api.get(`/student/notifications/${user.sicilNo}`);
      if (resp.data?.success) {
        setNotifications(resp.data.data.notifications || []);
        setUnreadCount(resp.data.data.unreadCount || 0);
      }
      // refresh notif meta version after full fetch
      try {
        const metaResp = await api.get(`/student/notifications/${user.sicilNo}`, { params: { meta: 1 } });
        const v = metaResp.data?.meta?.version || 0;
        const uc = metaResp.data?.meta?.unreadCount;
        if (typeof uc === 'number') setUnreadCount(uc);
        if (v) setNotifMetaVersion(v);
      } catch {}
    } catch (e) {
      // sessiz geç
    } finally {
      if (!options?.silent) setNotifLoading(false);
    }
  }, [getStudentUser]);

  const openNotifications = async () => {
    await fetchNotifications({ silent: false });
    setNotifOpen(true);
  };

  const closeNotifications = () => setNotifOpen(false);

  const markOneRead = async (id) => {
    try {
      await api.patch(`/student/notifications/${id}/read`);
      setNotifications(prev => prev.map(n => n._id === id ? { ...n, goruldu: true } : n));
      setUnreadCount(prev => Math.max(0, prev - 1));
    } catch (e) {
      // sessiz geç
    }
  };

  const markAllRead = async () => {
    try {
      const user = getStudentUser();
      if (!user?.sicilNo) return;
      await api.patch(`/student/notifications/${user.sicilNo}/read-all`);
      setNotifications(prev => prev.map(n => ({ ...n, goruldu: true })));
      setUnreadCount(0);
    } catch (e) {
      // sessiz geç
    }
  };

  // Basit relative time (tr)
  const timeAgo = (d) => {
    try {
      const ts = new Date(d).getTime();
      const diff = Math.max(0, Date.now() - ts);
      const mins = Math.floor(diff / 60000);
      if (mins < 1) return "az önce";
      if (mins < 60) return `${mins} dk önce`;
      const hrs = Math.floor(mins / 60);
      if (hrs < 24) return `${hrs} saat önce`;
      const days = Math.floor(hrs / 24);
      return `${days} gün önce`;
    } catch { return ""; }
  };

  const truncateText = (text, maxLength = 80) => {
    if (!text) return "";
    const str = String(text);
    return str.length > maxLength ? `${str.slice(0, maxLength)}...` : str;
  };

  useEffect(() => {
    if (activeTab === "basvurularim") {
      fetchStudentApplications();
    }
  }, [activeTab, fetchStudentApplications]);

  const renderAnaSayfaContent = () => {
    if (loading) {
      return (
        <div className="loading-state">
          <p>Yükleniyor...</p>
        </div>
      );
    }

    // İlan aktif değilse veya müsait birim yoksa dönem bitmiş mesajını göster
    if (!isAnnouncementActive || availableUnits.length === 0) {
      return (
        <div className="empty-state">
          <img src={studentHomeImg} alt="Boş içerik" className="empty-img1" />
          <p>
            Bu dönemki başvuru süreci bitmiştir.
            <br />
            Yeni dönem başvuruları için Kocaeli Üniversitesi duyurularını takip
            edebilirsiniz.
          </p>
        </div>
      );
    }

    // İlan aktif ve müsait birimler varsa iş ilanlarını göster
    return (
      <div className="job-listings">
        <div className="announcement-card">
          <h2 className="announcement-title">
            {announcementData?.title || "KISMI ZAMANLI ÇALIŞACAK ÖĞRENCİLERİN ALIM İLANI"}
          </h2>
          <div className="announcement-content">
            {announcementData ? (
              announcementData.content
                .split("\n")
                .filter((p) => p.trim().length > 0)
                .map((p, i) => <p key={i}>{p}</p>)
            ) : (
              <>
                <p>
                  Üniversitemiz 11/09/2024 tarihli ve 2024/9 nolu toplantısında alınan 97
                  sıra sayılı Yönetim Kurulu Kararına istinaden aylık KZÖ çalışma 30 saat ile
                  sınırlandırılmıştır. Çalışma saati brüt ücreti, 2025 yılı brüt saatlik
                  asgari ücret karşılığı kısmi zamanlı çalışacak öğrenci kontenjanları,
                  çalıştırılacak yer ve işin niteliği birimler itibarıyle belirlenmiş olup
                  aşağıdaki listede belirtilmiştir. Öğrencilerin çalışma süresi haftada en
                  fazla 15 saat olup, 01.09.2009 tarihinden itibaren Yüksek Öğretim Kurulu
                  tarafından yürürlüğe konulan Yükseköğretim Kurumları Kısmi Zamanlı Öğrenci
                  Çalıştırma Usul ve Esasları uyarınca çalıştırılacak öğrencilerde;
                </p>
                <div className="requirements-list">
                  <p>
                    1- Tezisiz yüksek lisans ve özel öğrenci hariç olmak üzere, Kocaeli
                    Üniversitesinde kayıtlı öğrenci olmak,
                  </p>
                  <p>2- Disiplin cezası almamış olmak,</p>
                  <p>
                    3- Yetim maaşı ve nafaka hariç asgari ücret düzeyinde bir gelire sahip
                    olmamak,
                  </p>
                  <p>
                    4- Kısmi zamanlı çalıştırılan öğrenci ile Üniversitemiz arasında yapılan
                    sözleşmeye aykırılık nedeniyle sözleşmesi feshedilmemiş olmak,
                  </p>
                  <p>
                    5- Çalıştırılacak iş için yeterli bilgi, beceri ve yeteneğe sahip olmak,
                  </p>
                  <p>6- Kayıt donduran öğrenci ve yabancı öğrenci olmamak,</p>
                  <p>
                    7- Normal eğitim-öğretim süresinde öğrenim görüyor olmak Deprem,sel gibi
                    doğal afetlerden zarar gördüğünü, şehit veya gazi çocuğu olduğunu
                    belgeleyen öğrenciler ve engelli öğrencilerden 2. 6. ve 7. maddeler
                    dışında yukarıdaki şartlar aranmaz.
                  </p>
                </div>
                <p>
                  Başvuru belgeleri aşağıda sunulmakta olup, Kısmi Zamanlı Öğrenci
                  Çalıştırma Başvuru Formu ile birlikte ilgili Fakülte/Yüksekokul/Enstitü/Meslek
                  Yüksekokulu/ Daire Başkanlıklarına yapılacaktır.
                </p>
                <p>
                  Başvuru süresi ilanın tarihinden itibaren 03/01/2025 tarihine kadardır.
                </p>
              </>
            )}
          </div>
        </div>

        <div className="application-card">
          <div className="action-buttons">
            <button className="student-download-btn" onClick={handleDownloadPDF}>
              <i className="fa-solid fa-download"></i>
            </button>
            
            <p className="download-text">
              Öğrenci başvuru belgesini indiriniz, belgeyi doldurup taratınız ve tarattığınız belgeyi sağ taraftaki yükleme alanından yükleyiniz.
            </p>

            <label className="student-upload-btn">
              <i className="fa-solid fa-upload"></i>
              <input 
                type="file" 
                accept=".pdf" 
                onChange={handleFileUpload}
                style={{display: 'none'}}
              />
            </label>
          </div>

          <div className="selection-row">
            <div className="unit-dropdown-wrap" ref={unitDropdownRef}>
              <button
                type="button"
                className={`unit-dropdown-trigger ${unitDropdownOpen ? "open" : ""}`}
                onClick={() => setUnitDropdownOpen((prev) => !prev)}
                aria-haspopup="listbox"
                aria-expanded={unitDropdownOpen}
                title={selectedWorkplaceLabel || "Başvurmak istediğiniz alanı seçiniz ..."}
              >
                <span className="unit-dropdown-text">
                  {selectedWorkplaceLabel || "Başvurmak istediğiniz alanı seçiniz ..."}
                </span>
                <i className="fa-solid fa-chevron-down"></i>
              </button>

              {unitDropdownOpen && (
                <div className="unit-dropdown-menu" role="listbox">
                  <button type="button" className="unit-dropdown-option placeholder" disabled>
                    Başvurmak istediğiniz alanı seçiniz ...
                  </button>
                  {availableUnits.flatMap((unit) =>
                    unit.workplaces
                      .filter((wp) => wp.bosKontenjan > 0)
                      .map((workplace) => {
                        const key = `${unit._id}|${workplace._id}`;
                        const disabled = blockedWorkplaces.has(key);
                        const isSelected = selectedWorkplace === key;
                        return (
                          <button
                            key={key}
                            type="button"
                            className={`unit-dropdown-option ${disabled ? "disabled" : ""} ${isSelected ? "selected" : ""}`}
                            onClick={() => handleWorkplaceChange(key)}
                            disabled={disabled}
                            role="option"
                            aria-selected={isSelected}
                          >
                            {unit.ustBirim.ustKurum} - {unit.birimAdi} - {workplace.calisacakYer} ({workplace.isAdi}) - Müsait: {workplace.bosKontenjan}
                            {disabled ? " (Başvuruldu)" : ""}
                          </button>
                        );
                      })
                  )}
                </div>
              )}
            </div>

            <button className="submit-btn-devam" onClick={handleSubmitApplication}>
              Devam Et
            </button>
          </div>

          {selectedWorkplaceLabel && (
            <div className="unit-dropdown-fulltext" aria-live="polite">
              {selectedWorkplaceLabel}
            </div>
          )}

          {uploadedFile && (
            <div className="file-info">
              <p>Yüklenen dosya: {uploadedFile.name}</p>
            </div>
          )}
        </div>

        {/* Student Info Modal */}
        {showStudentInfoModal && (
          <div className="modal-overlay" onClick={handleCloseModal}>
            <div className="student-info-modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Öğrenci Bilgileri</h3>
                <button className="modal-close-btn" onClick={handleCloseModal}>×</button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label htmlFor="adSoyad">Ad Soyad *</label>
                  <input
                    type="text"
                    id="adSoyad"
                    value={studentInfo.adSoyad}
                    onChange={(e) => handleStudentInfoChange('adSoyad', e.target.value)}
                    placeholder="Adınızı ve soyadınızı giriniz"
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="tcNo">TC Kimlik Numarası *</label>
                  <input
                    type="text"
                    id="tcNo"
                    value={studentInfo.tcNo}
                    onChange={(e) => handleStudentInfoChange('tcNo', e.target.value)}
                    placeholder="11 haneli TC kimlik numaranızı giriniz"
                    className="form-control"
                    maxLength="11"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="cancel-btn" onClick={handleCloseModal}>İptal</button>
                <button className="confirm-btn" onClick={handleConfirmApplication}>Onayla</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  // Click only if asil/yedek and check submission restrictions
  const handleApplicationClick = (application) => {
    if (application.status === "asil" || application.status === "yedek") {
      // Check if this is an asil application and student already has an asil submission
      if (application.status === "asil" && hasAsilSubmission) {
        alert("Zaten bir asil başvuru için belge gönderilmiş. Asil başvurular için sadece bir kez belge gönderilebilir.");
        return;
      }

      // Check if documents already submitted for this specific application
      if (documentSubmissionStatus?.submissions?.find(sub => sub.applicationId === application._id)) {
        alert("Bu başvuru için zaten belge gönderilmiş.");
        return;
      }

      setSelectedApplication(application);
      setReqUploads({});
    }
  };

  const backToList = () => {
    setSelectedApplication(null);
    setReqUploads({});
    setIbanText(""); // NEW: reset typed IBAN
  };

  const handleReqDownload = (key) => {
    const req = requirements.find(r => r.key === key);
    if (req && req.downloadable && req.file) {
      const link = document.createElement("a");
      link.href = req.file;
      if(req.id === 1){
        link.download = "kismi_zamanli_ogrenci_calistirma_sozlesmesi.pdf";
      }
      else if(req.id === 3){
        link.download = "aile_saglik_yardimi_sorgulama_belgesi.pdf";
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // fallback: başvuru formu
      const link = document.createElement("a");
      link.href = applicationFormFile;
      link.download = "kismi_zamanli_ogrenci_calistirma_basvuru_formu.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleReqFileChange = (id, file) => {
    if (!file) return;
    const lowerName = String(file.name || "").toLowerCase();
    if (file.type !== "application/pdf" && !lowerName.endsWith(".pdf")) {
      alert("Lütfen sadece PDF dosyası yükleyiniz.");
      return;
    }
    setReqUploads((prev) => ({ ...prev, [id]: file }));
  };

  // NEW: TR IBAN (Ziraat) validator
  const validateTrZiraatIban = (raw) => {
    const iban = String(raw || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
    if (!/^TR\d{24}$/.test(iban)) return false;                 // TR + 24 digits = 26 chars
    const bankCode = iban.substring(4, 9);                       // positions 5..9 (0-based 4..8)
    if (bankCode !== "00010") return false;                      // Ziraat = 00010
    // IBAN mod-97 checksum
    const rearr = iban.slice(4) + iban.slice(0, 4);
    let remainder = 0;
    for (let i = 0; i < rearr.length; i++) {
      const ch = rearr[i];
      const digits = ch >= 'A' && ch <= 'Z' ? String(ch.charCodeAt(0) - 55) : ch;
      for (let j = 0; j < digits.length; j++) {
        remainder = (remainder * 10 + parseInt(digits[j], 10)) % 97;
      }
    }
    return remainder === 1;
  };

  // NEW: derived input-format validation (TR + 24 digits)
  const ibanNorm = String(ibanText || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  const ibanFormatOk = /^TR\d{24}$/.test(ibanNorm);
  const showIbanFormatError = ibanTouched && ibanNorm.length > 0 && !ibanFormatOk;

 const submitRequirements = async () => {
  const uploadedCount = Object.keys(reqUploads).length;
  if (uploadedCount === 0) {
    alert("Lütfen en az bir belge yükleyiniz.");
    return;
  }

  if (!ibanText || !validateTrZiraatIban(ibanText)) {
    alert("Lütfen geçerli bir Ziraat Bankası IBAN'ı giriniz (TR ile başlayan 26 haneli ve bankası Ziraat olmalıdır).");
    return;
  }

  try {
    const formData = new FormData();
    formData.append('applicationId', selectedApplication._id);
    formData.append('ibanText', String(ibanText).toUpperCase());

    // FIXED: Add files with proper metadata using index
    let fileIndex = 0;
    Object.entries(reqUploads).forEach(([reqId, file]) => {
      const requirement = requirements.find(r => r.id === parseInt(reqId));
      if (requirement) {
        formData.append('documents', file);
        formData.append(`reqId_${fileIndex}`, reqId);        // ✅ Index-based
        formData.append(`reqKey_${fileIndex}`, requirement.key); // ✅ Index-based
        fileIndex++;
      }
    });

    const response = await api.post('/student/upload-documents', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.data.success) {
      alert('Belgeleriniz başarıyla yüklendi!');
      setSelectedApplication(null);
      setReqUploads({});
      setIbanText("");
      fetchDocumentSubmissionStatus();
      fetchStudentApplications();
    }
  } catch (error) {
    console.error('Belgeler yüklenirken hata:', error);
    alert(error.response?.data?.message || 'Belgeler yüklenirken hata oluştu');
  }
};

  // Role-özgü ve sekmeye özel kullanıcı okuma

  const handleLogout = () => {
    try { delete api.defaults.headers.common["Authorization"]; } catch {}
    localStorage.removeItem("token");
    localStorage.removeItem("tokenExpiresAt");
    localStorage.removeItem("user");
    localStorage.removeItem("studentUser");
    sessionStorage.removeItem("studentUser");
    navigate("/");
  };

  const HeaderActions = () => (
    <div className="header-actions" style={{ marginLeft: "auto", display: "inline-flex", gap: 10, position: "relative" }}>
      <button
        className="header-icon-btn"
        title="Bildirimler"
        onClick={openNotifications}
        style={{
          width: 40, height: 40, borderRadius: "50%",
          border: "2px solid #1ea54e",
          background: unreadCount > 0 ? "#e9f7ef" : "#fff",
          color: "#1ea54e",
          position: "relative"
        }}
      >
        <i className="fa-solid fa-bell"></i>
        {unreadCount > 0 && (
          <span
            style={{
              position: "absolute",
              top: -6,
              right: -6,
              minWidth: 18,
              height: 18,
              padding: "0 4px",
              background: "#d72538",
              color: "#fff",
              borderRadius: 12,
              fontSize: 11,
              lineHeight: "18px",
              textAlign: "center",
              boxShadow: "0 1px 4px rgba(0,0,0,0.2)"
            }}
          >
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>
      <button className="header-icon-btn" title="Çıkış Yap" onClick={handleLogout} style={{ width: 40, height: 40, borderRadius: "50%", border: "2px solid #1ea54e", background: "#fff", color: "#1ea54e" }}>
        <i className="fa-solid fa-arrow-right-from-bracket"></i>
      </button>
    </div>
  );

  // NEW: aktif part-time var mı?
  const fetchEmployment = useCallback(async () => {
    try {
      const user = getStudentUser();
      const sicilNo = user?.sicilNo;
      if (!sicilNo) return;
      const resp = await api.get(`/student/employment/${sicilNo}`);
      if (resp.data?.success) setEmployment(resp.data.data || null);
    } catch {}
  }, [getStudentUser]);

  // NEW: mevcut aya ait imza takvimini getir
  const fetchTimesheet = useCallback(async () => {
    try {
      const user = getStudentUser();
      const sicilNo = user?.sicilNo;
      if (!sicilNo) return;
      setTsLoading(true);
      const resp = await api.get(`/student/timesheet/${sicilNo}`);
      if (resp.data?.success) setTs(resp.data.data || null);
      else setTs(null);
    } catch {
      setTs(null);
    } finally {
      setTsLoading(false);
    }
  }, [getStudentUser]);

  // NEW: tabloda bir saat slotunu toggle et
  const toggleHour = async (date, hourIndex) => {
    if (!ts || !Array.isArray(ts.days)) return;
    const dayIdx = ts.days.findIndex(d => d.date === date);
    if (dayIdx === -1) return;

    const next = { ...ts, days: ts.days.map((d, i) => i === dayIdx ? { ...d, hours: [...d.hours] } : d) };
    next.days[dayIdx].hours[hourIndex] = !next.days[dayIdx].hours[hourIndex];

    // Optimistic update
    setTs(next);
    try {
      const getSicilNo = () => {
        try {
          const s1 = sessionStorage.getItem('studentUser');
          if (s1) return JSON.parse(s1)?.sicilNo;
          const l1 = localStorage.getItem('studentUser');
          if (l1) return JSON.parse(l1)?.sicilNo;
          const fb = localStorage.getItem('user');
          if (fb) {
            const u = JSON.parse(fb);
            return u?.type === 'student' ? u.sicilNo : null;
          }
          return null;
        } catch { return null; }
      };
      const sicilNo = getSicilNo();
      if (!sicilNo) return;
      await api.put(`/student/timesheet/${sicilNo}`, {
        month: ts.month,
        date,
        hours: next.days[dayIdx].hours
      });
    } catch {
      // başarısızlıkta state'i sunucu ile senkronla
      fetchTimesheet();
    }
  };

  // "Aylık İmza Takvimi" sekmesi açıldığında takvimi yükle
  useEffect(() => {
    if (activeTab === "imza" && employment) {
      fetchTimesheet();
      setTsEditMode(false); // sekme değişince düzenlemeyi kapat
    }
  }, [activeTab, employment]);

  // NEW: kaydet -> refetch + editMode kapat
  const saveTimesheet = async () => {
    try {
      await fetchTimesheet();
    } finally {
      setTsEditMode(false);
    }
  };

  // NEW: meta poller for student applications
  const scheduleAppsPoll = (delayMs) => {
    if (appsPollTimerRef.current) clearTimeout(appsPollTimerRef.current);
    appsPollTimerRef.current = setTimeout(doAppsPoll, delayMs);
  };

  const doAppsPoll = async () => {
    try {
      const user = getStudentUser();
      if (!user?.sicilNo) return;
      if (document.hidden || activeTab !== "basvurularim") {
        scheduleAppsPoll(15000);
        return;
      }
      const resp = await api.get(`/student/applications/${user.sicilNo}`, { params: { meta: 1 } });
      const v = resp.data?.meta?.version || 0;
      if (v && v !== appsMetaVersion) {
        await fetchStudentApplications();
        // Also refresh document submission status so UI buttons reflect changes
        fetchDocumentSubmissionStatus();
      }
      appsPollBackoffRef.current = 12000;
      scheduleAppsPoll(12000);
    } catch {
      const next = Math.min((appsPollBackoffRef.current || 12000) * 2, 60000);
      appsPollBackoffRef.current = next;
      scheduleAppsPoll(next);
    }
  };

  // NEW: start/stop apps polling based on tab and visibility
  useEffect(() => {
    const onVis = () => {
      if (!document.hidden && activeTab === "basvurularim") {
        doAppsPoll();
      }
    };
    document.addEventListener("visibilitychange", onVis);

    if (activeTab === "basvurularim") {
      scheduleAppsPoll(500);
    } else {
      if (appsPollTimerRef.current) clearTimeout(appsPollTimerRef.current);
    }
    return () => {
      document.removeEventListener("visibilitychange", onVis);
      if (appsPollTimerRef.current) clearTimeout(appsPollTimerRef.current);
    };
  }, [activeTab]); // eslint-disable-line react-hooks/exhaustive-deps

  // NEW: notification polling
  const scheduleNotifPoll = (delayMs) => {
    if (notifPollTimerRef.current) clearTimeout(notifPollTimerRef.current);
    notifPollTimerRef.current = setTimeout(doNotifPoll, delayMs);
  };

  const doNotifPoll = async () => {
    try {
      const user = getStudentUser();
      if (!user?.sicilNo) return;
      if (document.hidden) {
        scheduleNotifPoll(15000);
        return;
      }
      const resp = await api.get(`/student/notifications/${user.sicilNo}`, { params: { meta: 1 } });
      const meta = resp.data?.meta || {};
      const v = meta.version || 0;
      if (typeof meta.unreadCount === 'number') {
        setUnreadCount(meta.unreadCount); // update badge
      }
      if (v && v !== notifMetaVersion) {
        setNotifMetaVersion(v);
        if (notifOpen) {
          await fetchNotifications({ silent: true }); // refresh full list only if modal open
        }
      }
      notifPollBackoffRef.current = 12000;
      scheduleNotifPoll(12000);
    } catch {
      const next = Math.min((notifPollBackoffRef.current || 12000) * 2, 60000);
      notifPollBackoffRef.current = next;
      scheduleNotifPoll(next);
    }
  };

  // NEW: start/stop notification polling on mount + visibility
  useEffect(() => {
    const onVis = () => { if (!document.hidden) doNotifPoll(); };
    document.addEventListener("visibilitychange", onVis);
    scheduleNotifPoll(800);
    return () => {
      document.removeEventListener("visibilitychange", onVis);
      if (notifPollTimerRef.current) clearTimeout(notifPollTimerRef.current);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="student-page-wrapper">
      <header className="student-header">
        <div className="header-content">
          <img src={kouLogo} alt="KOU Logo" className="header-logo" />
          <h1 className="header-title">
            Kısmi Zamanlı Öğrenci Süreç Takip Sistemi
          </h1>
          <HeaderActions />
        </div>
      </header>

      <main className="student-main">
        <div className="student-tabs">
          <button
            className={`student-tab-btn ${
              activeTab === "anasayfa" ? "active" : ""
            }`}
            onClick={() => setActiveTab("anasayfa")}
          >
            Ana Sayfa
          </button>
          <button
            className={`student-tab-btn ${
              activeTab === "basvurularim" ? "active" : ""
            }`}
            onClick={() => setActiveTab("basvurularim")}
          >
            Başvurularım
          </button>
          {employment && (
            <button
              className={`student-tab-btn ${activeTab === "imza" ? "active" : ""}`}  // NEW
              onClick={() => setActiveTab("imza")}
              title="Aylık İmza Takvimi"
            >
              Aylık İmza Takvimi
            </button>
          )}
        </div>

        <div className="student-tab-content">
          {activeTab === "anasayfa" && renderAnaSayfaContent()}
          {activeTab === "basvurularim" && (
            <>
              {selectedApplication ? (
                <>
                  <div className="application-detail">
                    {/* 1) Back button anchored to the left of the top table + info card */}
                    <div className="app-info-wrap">
                      <button className="back-to-list-btn" onClick={backToList} title="Başvurulara geri dön">
                        <i className="fa-solid fa-chevron-left"></i>
                      </button>
                      <div className="app-info-card">
                         <div className="app-info-title">
                           {selectedApplication.unit.birimAdi}
                         </div>
                         <div className="app-info-head">
                           <div>Çalıştırılacak Yer</div>
                           <div>İşin Adı / Niteliği</div>
                         </div>
                         <div className="app-info-row">
                           <div>{selectedApplication.workplaceInfo.calisacakYer}</div>
                           <div>{selectedApplication.workplaceInfo.isAdi}</div>
                         </div>
                       </div>
                     </div>

                     {/* NEW: Rejection warning for resubmit */}
                     {selectedApplication.rejectionType === 'resubmit' && (
                       <div className="rejection-warning-banner">
                         <i className="fa-solid fa-exclamation-triangle"></i>
                         <span>Belgelerinizde düzeltme lazım. Lütfen belgelerinizi tekrar yükleyiniz.</span>
                       </div>
                     )}
 
                     {/* 2) Belgeler tablosu */}
                     <div className="requirements-table">
                       <div className="req-header">
                         <div className="col-sira">Sıra</div>
                         <div className="col-ad">Belge Adı</div>
                         <div className="col-indir">Belge İndir</div>
                         <div className="col-yukle">Belge Yükle</div>
                       </div>

                      {requirements.map((req) => {
                        // NEW: Special rendering for row 6 (IBAN text) -> no download/upload cells
                        if (req.id === 6) {
                          return (
                            <div key={req.id} className="req-row">
                              <div className="col-sira">{req.id}</div>
                              <div
                                className="col-ad"
                                style={{ gridColumn: "2 / 5" /* span Belge Adı + İndir + Yükle */ }}
                              >
                                <div className="iban-inline">
                                  <span className="iban-label">{req.name}</span>
                                  <input
                                    type="text"
                                    className={`iban-input ${showIbanFormatError ? "invalid" : ""}`}
                                    value={ibanText}
                                    onChange={(e) => setIbanText(e.target.value)}
                                    onBlur={() => setIbanTouched(true)}
                                    placeholder="TR________________________"
                                    title="Ziraat Bankası IBAN'ınızı giriniz (TR ile başlayan 26 hane)"
                                    maxLength={26}
                                    pattern="^TR\d{24}$"
                                    aria-invalid={showIbanFormatError ? "true" : "false"}
                                  />
                                                                  <div className="iban-help">
                                  Lütfen iban gösterir belgedeki ibanın aynısını girin.
                                </div>
                                </div>
                             
                                {showIbanFormatError && (
                                  <div className="iban-error">
                                    IBAN formatı TR ile başlayan 26 hane olmalıdır (ör. TR1234...).
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        }

                        // Default rendering for other rows
                        return (
                          <div key={req.id} className="req-row">
                            <div className="col-sira">{req.id}</div>
                            <div className="col-ad">{req.name}</div>
                            <div className="col-indir">
                              {req.downloadable && req.file ? (
                                <button
                                  className="icon-btn download"
                                  onClick={() => handleReqDownload(req.key)}
                                  title="İndir"
                                >
                                  <i className="fa-solid fa-download"></i>
                                </button>
                              ) : (
                                <span className="dash">-</span>
                              )}
                            </div>
                            <div className="col-yukle">
                              <label className="icon-btn upload" title="Yükle">
                                <i className="fa-solid fa-upload"></i>
                                <input
                                  type="file"
                                  accept=".pdf"
                                  onChange={(e) => handleReqFileChange(req.id, e.target.files?.[0])}
                                  style={{ display: "none" }}
                                />
                              </label>
                              {reqUploads[req.id] && (
                                <span className="uploaded-hint" title={reqUploads[req.id].name}>Yüklendi</span>
                              )}
                            </div>
                          </div>
                        );
                      })}
                     </div>
 
                     {/* Alt sağ: Gönder butonu + bekleyenler rozeti */}
                     <button
                       className="submit-req-btn"
                       onClick={submitRequirements}
                       title="Belgeleri gönder"
                     >
                       <i className="fa-solid fa-check"></i>
                     </button>

                   </div>
                </>
              ) : (
                <>
                  {applications.length > 0 && (
                    <>
                      <div className="student-status-legend">
                        <h5>Renk Kodlaması :</h5>
                        <div className="student-legend-items">
                          <div className="student-legend-item">
                            <div className="student-legend-color beklemede"></div>
                            <span>: Beklemede</span>
                          </div>
                          <div className="student-legend-item">
                            <div className="student-legend-color reddedildi"></div>
                            <span>: Reddedildi</span>
                          </div>
                          <div className="student-legend-item">
                            <div className="student-legend-color yedek"></div>
                            <span>: Yedek</span>
                          </div>
                          <div className="student-legend-item">
                            <div className="student-legend-color asil"></div>
                            <span>: Asil</span>
                          </div>
                        </div>
                      </div>
                      
                      <div className="student-filter-container">
                        <button 
                          className="student-filter-btn"
                          onClick={() => setShowFilterDropdown(!showFilterDropdown)}
                          title="Başvuruları Filtrele"
                        >
                          <i className="fa-solid fa-filter"></i>
                        </button>
                        
                        {showFilterDropdown && (
                          <div className="student-filter-dropdown">
                            <button 
                              className={`student-filter-option ${filterStatus === 'all' ? 'active' : ''}`}
                              onClick={() => filterApplications('all')}
                            >
                              Tümü ({applications.length})
                            </button>
                            <button 
                              className={`student-filter-option ${filterStatus === 'asil' ? 'active' : ''}`}
                              onClick={() => filterApplications('asil')}
                            >
                              Asil ({applications.filter(app => app.status === 'asil').length})
                            </button>
                            <button 
                              className={`student-filter-option ${filterStatus === 'yedek' ? 'active' : ''}`}
                              onClick={() => filterApplications('yedek')}
                            >
                              Yedek ({applications.filter(app => app.status === 'yedek').length})
                            </button>
                            <button 
                              className={`student-filter-option ${filterStatus === 'beklemede' ? 'active' : ''}`}
                              onClick={() => filterApplications('beklemede')}
                            >
                              Beklemede ({applications.filter(app => app.status === 'beklemede').length})
                            </button>
                            <button 
                              className={`student-filter-option ${filterStatus === 'reddedildi' ? 'active' : ''}`}
                              onClick={() => filterApplications('reddedildi')}
                            >
                              Reddedildi ({applications.filter(app => app.status === 'reddedildi').length})
                            </button>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                  
                  <div className="applications-list">
                    {applications.length === 0 ? (
                      <div className="student-empty-state2">
                        <img src={studentHomeImg2} alt="Boş içerik" className="student-empty-img2" />
                        <p>
                          Henüz bir başvurunuz yok. <br />
                          Ana sayfadan başvuru oluşturabilirsiniz.
                        </p>
                      </div>
                    ) : (
   <>
    <div className="applications-content">
      {currentApplications.map((application) => {
        const hasSubmitted =
          documentSubmissionStatus?.submittedApplicationIds?.includes(application._id)
          || documentSubmissionStatus?.submissions?.some(sub => sub.applicationId === application._id);

        const isAsilRestricted = application.status === 'asil' && hasAsilSubmission;

        // NEW: Red durumu kontrolleri
        const isRejectedFinal = application.status === 'reddedildi' && application.rejectionType === 'final';
        const isRejectedResubmit = application.rejectionType === 'resubmit' && !hasSubmitted;

        // ✅ NEW: İşe alınan başvurular tıklanamaz
        const canClick = (
          (
            !application.hired && // ✅ İşe alınmamış olmalı
            !isRejectedFinal && // Red yiyenler tıklanamaz (final)
            (application.status === 'asil' || application.status === 'yedek') &&
            !hasSubmitted &&
            !isAsilRestricted
          ) ||
          isRejectedResubmit // Belge düzeltmesi gerekiyorsa tıklanabilir
        );

        return (
          <div
            key={application._id}
            className={`application-item ${application.status} ${
              canClick ? 'clickable' : ''
            } ${hasSubmitted ? 'submitted' : ''} ${application.hired ? 'hired' : ''} ${isRejectedFinal ? 'rejected-final' : ''} ${isRejectedResubmit ? 'rejected-resubmit' : ''}`}
            onClick={canClick ? () => handleApplicationClick(application) : undefined}
            role={canClick ? 'button' : 'article'}
            aria-disabled={!canClick}
            title={
              isRejectedFinal ? `Başvurunuz reddedildi: ${application.rejectionReason}` :
              isRejectedResubmit ? 'Belgelerinizi düzeltmek için tıklayın' :
              application.hired ? 'İşe alındınız - Bu başvuru tamamlandı' :
              hasSubmitted ? 'Başvuru tamamlandı' :
              isAsilRestricted ? 'Asil başvuru için zaten belge gönderilmiş' :
              (application.status === 'asil' || application.status === 'yedek') ? 
              'Belge yüklemek için tıklayın' : undefined
            }
          >
            <div className="application-content">
              <div className="application-left">
                <h3 className="unit-name">{application.unit.ustBirim.ustKurum}</h3>
                <h4 className="department-name">{application.unit.birimAdi}</h4>
              </div>
              <div className="application-right">
                <h4 className="workplace-name">
                  {application.workplaceInfo.calisacakYer}
                  {application.hired && <span className="status-badge hired"> (İşe Alındınız)</span>}
                  {isRejectedFinal && <span className="status-badge rejected"> (Admin Tarafından Reddedildi)</span>}
                  {isRejectedResubmit && <span className="status-badge rejected-resubmit"> (Düzeltme lazım)</span>}
                  {hasSubmitted && !application.hired && !isRejectedResubmit && <span className="status-badge submitted"> (Belge Gönderildi)</span>}
                </h4>
                <p className="job-title" title={application.workplaceInfo.isAdi}>
                  {truncateText(application.workplaceInfo.isAdi)}
                </p>

              </div>
            </div>
            <div className={`status-indicator ${application.status} ${isRejectedFinal ? 'rejected-final' : ''} ${isRejectedResubmit ? 'rejected-resubmit' : ''}`}></div>
          </div>
        );
      })}
    </div>

                        {/* Pagination Controls */}
                        {totalPages > 1 && (
                          <div className="pagination-container">
                            <div className="pagination">
                              <button 
                                className="pagination-btn prev-btn"
                                onClick={goToPrevPage}
                                disabled={currentPage === 1}
                                title="Önceki Sayfa"
                              >
                                <i className="fa-solid fa-chevron-left"></i>
                              </button>
                              
                              <div className="page-numbers">
                                <span className="page-indicator">
                                  {currentPage}
                                </span>
                              </div>
                              
                              <button 
                                className="pagination-btn next-btn"
                                onClick={goToNextPage}
                                disabled={currentPage === totalPages}
                                title="Sonraki Sayfa"
                              >
                                <i className="fa-solid fa-chevron-right"></i>
                              </button>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </>
              )}
            </>
          )}

          {/* NEW: Aylık İmza Takvimi */}
          {activeTab === "imza" && (
            <div className="tsc-inline">
              <TimesheetCalendar
                employment={employment}
                timesheet={ts}
                loading={tsLoading}
                onToggleHour={toggleHour}
                editMode={tsEditMode} // NEW
              />
              <div className="tsc-side">
                {!tsEditMode ? (
                  <button
                    className="tsc-save-btn"
                    onClick={() => setTsEditMode(true)}
                    disabled={tsLoading || !employment || !ts}
                    title="Güncelle"
                  >
                    <i className="fa-solid fa-pencil"></i>
                  </button>
                ) : (
                  <button
                    className="tsc-save-btn"
                    onClick={saveTimesheet}
                    disabled={tsLoading || !employment || !ts}
                    title="Kaydet"
                  >
                    <i className="fa-solid fa-check"></i>
                  </button>
                )}
              </div>
            </div>
          )}
            
          

        </div>
      </main>

      {/* Notifications Modal - reuse existing modal overlay styles */}
      {notifOpen && (
        <div className="modal-overlay" onClick={closeNotifications}>
          <div className="student-info-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 680 }}>
            <div className="modal-header">
              <h3>Bildirimler</h3>
              <div style={{ marginLeft: "auto", display: "inline-flex", gap: 8 }}>
                <button className="confirm-btn" onClick={markAllRead} disabled={unreadCount === 0}>
                  Tümünü Okundu İşaretle
                </button>
                <button className="modal-close-btn" onClick={closeNotifications}>×</button>
              </div>
            </div>
            <div className="modal-body" style={{ maxHeight: 520, overflowY: "auto", paddingTop: 8 }}>
              {notifLoading ? (
                <div style={{ padding: 12, color: "#666", fontSize: 14 }}>Yükleniyor...</div>
              ) : notifications.length === 0 ? (
                <div style={{ padding: 12, color: "#666", fontSize: 14 }}>Gösterilecek bildiriminiz yok.</div>
              ) : (
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {notifications.map(n => (
                    <li
                      key={n._id}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr auto",
                        gap: 8,
                        padding: "10px 8px",
                        borderBottom: "1px solid #eee",
                        background: n.goruldu ? "#fff" : "#f9fffb"
                      }}
                    >
                      <div>
                        <div style={{ fontSize: 14, color: "#111827", fontWeight: n.goruldu ? 400 : 600 }}>
                          {n.message}
                        </div>
                        <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>
                          {timeAgo(n.saat || n.createdAt)}
                        </div>
                      </div>
                      <div>
                        {!n.goruldu && (
                          <button className="cancel-btn" onClick={() => markOneRead(n._id)} style={{ padding: "6px 10px" }}>
                            Okundu
                          </button>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default StudentHomePage;

